export const UNKNOWN_IP_LOCATION = '未知';
export const OFFICIAL_IP_LOCATION = '北京';

export const IP_LOCATION_WHITELIST: string[] = ['2646275029618626'];
